<app-card #card 
    [cardTitle]="'ROLES.TITLE' | translate"    
    [useExternalButtons]="true" 
    [showEdit]="true" 
    [editDisabled]="!allowEdit">

    <div>
        <div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'ROLES.COMPANY_SEARCH' | translate }}</mat-label>
                <input matInput type="text" [formControl]="searchControl" autocomplete="off">
                <button *ngIf="searchControl.value" matSuffix mat-icon-button [aria-label]="'ROLES.DELETE' | translate" (click)="clearText()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

            <ng-container *ngIf="items$ | async as items">
                <div class="message-panel">
                    {{ searchMessage }}
                </div>
                <div class="scroll-panel height-medium padding-xs">
                    <app-dynamic-list-item [actionState]="card.actionState" [inlineEdit]="false" [disableActions]="!isAllowChange" [disableActionsMessage]="'ROLES.OWN_ROLE_CANNOT_MODIFY' | translate"
                        (edit)="rowEdit(item.itemSource)"
                        (delete)="rowDelete(item.itemSource)"
                        *ngFor="let item of items; index as i" [index]="i" [source]="item">
                        <div slot="readonly">
                            <div class="flex-horizontal mainitems" >
                                <div class="field-company" [title]="'ROLES.COMPANY' | translate">{{ item.itemSource.companyName }}</div>
                                <div class="field-role" [title]="'ROLES.ROLE' | translate">{{ item.itemSource.roleName | roleDisplayName }}</div>
                            </div>
                        </div>
                    </app-dynamic-list-item>
                </div>
                <mat-paginator #paginator [length]="total"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pagingSettingsChanged($event)"
                            [aria-label]="'ROLES.CHOOSE_PAGE' | translate">
                </mat-paginator>

                <button mat-icon-button color="primary" (click)="add()" *ngIf="card.actionState.editMode" [disabled]="!isAllowChange" [title]="isAllowChange ? '' : ('ROLES.OWN_ROLE_CANNOT_MODIFY' | translate)">
                    <mat-icon>add_circle_outline</mat-icon>
                </button>

            </ng-container>

        </div>
    </div>

</app-card>
